export default [
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/onboarding/:client_id',
        name: 'Onboarding',
        components: {
            default: () => import('../pages/Account/Onboarding.vue')
        },
        meta: {
            // guest: true,
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_users',
            show_in_search: true
        },
    },
    {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        components: {
            default: () => import('../pages/PrivacyPolicy.vue')
        },
        meta: {
            // guest: true,
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_users',
            show_in_search: true
        },
    },
    {
        path: '/reset',
        name: 'Reset Code',
        components: {
            default: () => import('../pages/Account/ResetCode.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reset-account',
        name: 'Reset Password',
        components: {
            default: () => import('../pages/Account/ResetPassword.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/listings',
        name: 'Properties',
        components: {
            default: () => import('../pages/layout/Properties.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        components: {
            default: () => import('../pages/Dashboard/Dashboard.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Reachable by any authenticated user - it's the caller's own
        // business's bill, same reasoning as /unlock-account (no specific
        // permission gate). Used before a business is ever blocked; once
        // actually blocked, EnsureBusinessNotBlocked redirects everywhere
        // to /unlock-account instead (see client.js's response interceptor).
        path: '/business-invoice/pay',
        name: 'PayBusinessInvoice',
        components: {
            default: () => import('../pages/Dashboard/PayBusinessInvoice.vue')
        },
        meta: {
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Reachable by any authenticated user regardless of role - same as
        // /dashboard itself, not gated behind a specific permission (it's
        // your own account/business, not a resource someone else manages).
        path: '/profile',
        name: 'Profile',
        components: {
            default: () => import('../pages/Dashboard/Profile.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },

    // {
    //     path: '/properties/:id',
    //     name: 'Property Detail',
    //     components: {
    //         default: () => import(/* webpackChunkName: "auth" */ '../pages/layout/PropertyDetail'),
    //     },
    //     meta: {
    //         show_in_search: false
    //     }
    // },
    {
        path: '/auth/:hash?',
        name: 'Login',
        components: {
            default: () => import('../pages/Account/Auth')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/unlock-account/:token',
        name: 'UnlockAccount',
        components: {
            default: () => import('../pages/Account/UnlockAccount.vue')
        },
        meta: {
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/verify-email/:token',
        name: 'VerifyEmail',
        components: {
            default: () => import('../pages/Account/VerifyEmail.vue')
        },
        meta: {
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/tenancies/accept',
        name: 'ApproveTenancy',
        components: {
            default: () => import('../pages/Account/AcceptTenancy.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/visitors/check-in/:tracker/:otp?',
        name: 'ApproveCheckIn',
        components: {
            default: () => import('../pages/Visitors/CheckInVisitor.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/register',
        name: 'Create Account',
        components: {
            default: () => import('../pages/Account/Register.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/verify-account',
        name: 'Verify Account',
        components: {
            default: () => import('../pages/Account/VerifyAccount.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/add-property/:property_id?',
        name: 'Add Property',
        components: {
            default: () => import('../pages/Dashboard/AddProperty.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/property-units/edit/:property_id/:unit_id?',
        name: 'Add Unit',
        components: {
            default: () => import('../pages/Dashboard/AddUnit.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/property-units/bulk/:property_id?',
        name: 'Add Bulk Units',
        components: {
            default: () => import('../pages/Dashboard/AddBulkUnits.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/properties/units/:property_id',
        name: 'Show Units',
        components: {
            default: () => import('../pages/Dashboard/PropertyUnits.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/my-properties',
        name: 'My Properties',
        components: {
            default: () => import('../pages/Dashboard/MyProperties.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/my-listings',
        name: 'My Listings',
        components: {
            default: () => import('../pages/Dashboard/Listings.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        components: {
            default: () => import('../pages/Dashboard/ReportsHub.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reports/rent-roll',
        name: 'Rent Roll Report',
        components: {
            default: () => import('../pages/Dashboard/ReportsRentRoll.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reports/occupancy',
        name: 'Occupancy Report',
        components: {
            default: () => import('../pages/Dashboard/ReportsOccupancy.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reports/income-expense',
        name: 'Income vs Expense Report',
        components: {
            default: () => import('../pages/Dashboard/ReportsIncomeExpense.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/reports/maintenance',
        name: 'Maintenance Report',
        components: {
            default: () => import('../pages/Dashboard/ReportsMaintenance.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/my-properties/:property_id',
        name: 'Property Details',
        components: {
            default: () => import('../pages/Dashboard/PropertyDetails.vue')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Performance Report is now a tab on Property Details rather than
        // its own page (see PropertyDetails.vue's activeTab) - kept as a
        // redirect so any existing bookmarks/links to the old URL still land
        // somewhere useful.
        path: '/my-properties/:property_id/performance-report',
        redirect: to => ({path: `/my-properties/${to.params.property_id}`, query: {tab: 'performance'}})
    },
    {
        path: '/contact-us',
        name: 'Contact Us',
        components: {
            default: () => import('../pages/Contact')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/about-us',
        name: 'About Us',
        components: {
            default: () => import('../pages/About')
        },
        meta: {
            // auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Tenants list now lives as a tab on the merged Tenancies screen.
        path: '/tenants',
        redirect: '/tenancies?tab=tenants'
    },
    {
        path: '/tenants/:tenant_id',
        name: 'Tenants Details',
        components: {
            default: () => import('../pages/Dashboard/TenantDetail.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/campaigns/:id',
        name: 'View Campaign',
        components: {
            default: () => import('../pages/Dashboard/CampaignDetails.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/tenancies',
        name: 'Tenancies',
        components: {
            default: () => import('../pages/Dashboard/Tenancies.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Pending Tenancies now lives as a tab on the merged Tenancies screen.
        path: '/pending-tenancies',
        redirect: '/tenancies?tab=pending'
    },
    {
        path: '/tickets',
        name: 'Tickets',
        components: {
            default: () => import('../pages/Dashboard/Tickets.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/visitors',
        name: 'Visitors',
        components: {
            default: () => import('../pages/Dashboard/Visitors.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/property-settings',
        name: 'PropertySettings',
        components: {
            default: () => import('../pages/Dashboard/PropertySettings.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/system-users',
        name: 'Users',
        components: {
            default: () => import('../pages/Dashboard/Users.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/tenants/add/:tenant_id?',
        name: 'Add Tenant',
        components: {
            default: () => import('../pages/Dashboard/AddTenant.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/users/add/:user_id?',
        name: 'Add User',
        components: {
            default: () => import('../pages/Dashboard/AddUser.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/tenancies/metred-charges/:tenancy_id',
        name: 'Metred Charges',
        components: {
            default: () => import('../pages/Dashboard/TenancyMetredCharges.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/roles',
        name: 'View Roles',
        components: {
            default: () => import('../pages/Dashboard/Roles.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/campaigns',
        name: 'View Campaigns',
        components: {
            default: () => import('../pages/Dashboard/Campaigns.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/campaigns/add/:campaign_id?',
        name: 'Add Campaign',
        components: {
            default: () => import('../pages/Dashboard/AddCampaign.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/roles/add/:role_id?',
        name: 'Add Role',
        components: {
            default: () => import('../pages/Dashboard/AddRole.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/roles/permissions/:role_id?',
        name: 'Role Permissions',
        components: {
            default: () => import('../pages/Dashboard/RolePermissions.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/users/roles/:user_id',
        name: 'User Roles',
        components: {
            default: () => import('../pages/Dashboard/UserRoles.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/users/properties/:user_id',
        name: 'User Properties',
        components: {
            default: () => import('../pages/Dashboard/UserProperties.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/tenants/tenancies/:tenant_id',
        name: 'Tenant Tenancies',
        components: {
            default: () => import('../pages/Dashboard/AllocateUnits.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/bills',
        name: 'Bills',
        components: {
            default: () => import('../pages/Dashboard/Bills.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/bills/review',
        name: 'BillReview',
        components: {
            default: () => import('../pages/Dashboard/BillReview.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/charges',
        name: 'Charges Component',
        components: {
            default: () => import('../pages/Dashboard/Charges.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/expenses',
        name: 'Expenses Component',
        components: {
            default: () => import('../pages/Dashboard/Expenses.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/vendors',
        name: 'Vendors Component',
        components: {
            default: () => import('../pages/Dashboard/Vendors.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/e-rits',
        name: 'Erits Component',
        components: {
            default: () => import('../pages/Dashboard/Erits.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/charges/add/:charge_id?',
        name: 'Add Charges',
        components: {
            default: () => import('../pages/Dashboard/AddCharge.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/expenses/add/:expense_id?',
        name: 'Add Expenses',
        components: {
            default: () => import('../pages/Dashboard/AddExpenses.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/vendors/add/:vendor_id?',
        name: 'Add Vendors',
        components: {
            default: () => import('../pages/Dashboard/AddVendor.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Charge Types now lives as a tab on the merged Charges screen.
        path: '/charge-types',
        redirect: '/charges?tab=types'
    },
    {
        // Expense Categories now lives as a tab on the merged Expenses screen.
        path: '/expense-categories',
        redirect: '/expenses?tab=categories'
    },
    {
        // Vendor Categories now lives as a tab on the merged Vendors screen.
        path: '/vendor-categories',
        redirect: '/vendors?tab=categories'
    },
    {
        path: '/charge-types/add/:charge_type_id?',
        name: 'Add Charge Types',
        components: {
            default: () => import('../pages/Dashboard/AddChargeTypes.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/expense-categories/add/:expense_category_id?',
        name: 'Add Expense Categories',
        components: {
            default: () => import('../pages/Dashboard/AddExpenseCategories.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/vendor-categories/add/:vendor_category_id?',
        name: 'Add Vendor Categories',
        components: {
            default: () => import('../pages/Dashboard/AddVendorCategories.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/payments',
        name: 'Payments',
        components: {
            default: () => import('../pages/Dashboard/Payments.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/settlements',
        name: 'Settlements',
        components: {
            default: () => import('../pages/Dashboard/Settlements.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/business-invoices',
        name: 'BusinessInvoices',
        components: {
            default: () => import('../pages/Dashboard/BusinessInvoices.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/plan-limit',
        name: 'PlanLimit',
        components: {
            default: () => import('../pages/Dashboard/PlanLimit.vue')
        },
        meta: {
            auth: false,
            show_in_search: false
        }
    },
    {
        path: '/landlord-invoices',
        name: 'LandlordInvoices',
        components: {
            default: () => import('../pages/Dashboard/LandlordInvoices.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/penalties',
        name: 'Penalties',
        components: {
            default: () => import('../pages/Dashboard/Penalties.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        // Penalty Settings now lives as a tab on the merged Penalties screen.
        path: '/penalty-settings',
        redirect: '/penalties?tab=settings'
    },
    {
        path: '/payments/add/:payment_id?',
        name: 'Add Payments',
        components: {
            default: () => import('../pages/Dashboard/AddPayment.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/bills/add/:bill_id?',
        name: 'Add Bill',
        components: {
            default: () => import('../pages/Dashboard/AddBill.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/pay/:account_number',
        name: 'Pay',
        components: {
            default: () => import('../pages/Payments/Checkout.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/sms-logs',
        name: 'SMS Logs',
        components: {
            default: () => import('../pages/Dashboard/SmsLogs.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/leases/sign/:id',
        name: 'Sign Lease',
        components: {
            default: () => import('../components/Leases/LeaseSign.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/lease-templates/create/:id?',
        name: 'Create Templates',
        components: {
            default: () => import('../components/Leases/CreateLeaseTemplate.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/lease-templates',
        name: 'Lease Templates',
        components: {
            default: () => import('../components/Leases/LeaseTemplates.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/leases',
        name: 'Leases',
        components: {
            default: () => import('../components/Leases/Leases.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
    {
        path: '/leases/create',
        name: 'Create Leases',
        components: {
            default: () => import('../components/Leases/CreateLease.vue')
        },
        meta: {
            auth: false,
            parent_key: 'view_settings_nav',
            key: 'view_create_users',
            show_in_search: false
        }
    },
];
